module.exports = __webpack_public_path__ + "img/excel.66d00696.svg";